<template>
  <el-tabs ref='titleBadge' v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane name="first">  
      <span slot="label">  
      全部  
      <el-badge :value="allCount" class="item" type="primary"></el-badge> 
      </span>  
      <StatisticsCentreAllList v-if="activeName === 'first'" ref="first" @myevent="getStatisticsCentreViewModelsEntity"></StatisticsCentreAllList>
    </el-tab-pane> 
    <el-tab-pane name="second">  
      <span slot="label">  
      异常  
      <el-badge :value="abnormalCount" class="item" type="primary"></el-badge> 
      </span>  
      <StatisticsCentreAbnormalList v-if="activeName === 'second'" ref="second" @myevent="getStatisticsCentreViewModelsEntity"></StatisticsCentreAbnormalList>
    </el-tab-pane> 
    <el-tab-pane name="third">  
      <span slot="label">  
      取消  
      <el-badge :value="cancelCount" class="item"></el-badge>  
      </span>  
      <StatisticsCentreCancelList v-if="activeName === 'third'" ref="third" @myevent="getStatisticsCentreViewModelsEntity"></StatisticsCentreCancelList>
    </el-tab-pane>  
  </el-tabs>
</template>
<script>
  import { getStatisticsCentreViewModels } from "../../api/api";
  import StatisticsCentreAllList from "./StatisticsCentreAll";
  import StatisticsCentreAbnormalList from "./StatisticsCentreAbnormal";
  import StatisticsCentreCancelList from "./StatisticsCentreCancel";
  import { currentMonthFirstLastDayArr } from '../../baseCommon.js';

  export default {
    components: {
      StatisticsCentreAllList,
      StatisticsCentreAbnormalList,
      StatisticsCentreCancelList
    },
    data() {
      return {
        activeName: 'first',
        allCount: 0,
        abnormalCount: 0,
        cancelCount: 0
      };
    },
    methods: {
      handleClick(tab, event) {
        this.activeName = tab.name;
      },
      //获取统计中心所有、异常、取消数据数
      getStatisticsCentreViewModelsEntity() {
        let para = {
          departureDate : currentMonthFirstLastDayArr()
        };
        getStatisticsCentreViewModels(para).then(res => {
          this.allCount = res.data.AllCount;
          this.abnormalCount = res.data.AbnormalCount;
          this.cancelCount = res.data.CancelCount;
        });
      }
    },
    mounted(){
      this.getStatisticsCentreViewModelsEntity();
    },
  };
</script>